import axios from "axios";
import { Controller } from "stimulus";

function csrfToken(): string {
  return (
    document
      .querySelector("meta[name='csrf-token']")
      ?.getAttribute("content") || ""
  );
}

function applyReplaceContent(replaceContent?: Record<string, string>): void {
  if (!replaceContent) return;

  Object.keys(replaceContent).forEach((selectorId) => {
    const element = document.getElementById(selectorId);
    if (element) element.innerHTML = replaceContent[selectorId];
  });
}

export default class extends Controller {
  static values = { url: String };

  declare urlValue: string;

  async remove(event: Event): Promise<void> {
    event.preventDefault();

    const { data } = await axios.delete(this.urlValue, {
      headers: {
        "X-CSRF-Token": csrfToken(),
        Accept: "application/json",
      },
    });

    applyReplaceContent(data.replace_content);
  }
}
